// SPEC-065: whether a plan is bought once rather than subscribed to is read
// from the API — PlanSerializer sends `is_one_time_purchase` as a boolean,
// true only for a one-time purchase — never from the plan's name or id, and
// never from billing_frequency (Lifetime carries the same value as Monthly).
// A plan object that lacks the field (a backend that does not send it yet,
// older persisted state) keeps today's "subscribing" copy.
const planIsOneTimePurchase = (plan) => plan?.isOneTimePurchase === true

export default planIsOneTimePurchase
